<template>
  <el-dialog
    :visible.sync="show"
    :show-close="false"
    custom-class="dialog"
    width="380px"
    center
  >
    <template #title>
      <span class="login-title">{{
        formData.type ? "账号密码登录" : "验证码登录"
      }}</span>
    </template>
    <div>
      <el-form :model="formData" :rules="rules" :inline-message="true">
        <!--手机号-->
        <el-form-item prop="phone" :label="formData.type ? '账号' : '手机号'" class="form-item">
          <el-input
            v-model="formData.phone"
            placeholder="请输入手机号"
            type="number"
            maxlength="11"
            prefix-icon="el-icon-mobile-phone"
          ></el-input>
        </el-form-item>

        <!--密码-->
        <el-form-item prop="password" label="密码" class="form-item" v-if="formData.type">
          <el-input
            v-model="formData.password"
            placeholder="请输入密码"
            maxlength="18"
            minlength="6"
            type="text"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>

        <!--验证码-->
        <el-form-item
          prop="password"
          label="验证码"
          class="form-item"
          v-if="!formData.type"
        >
          <div class="code">
            <span>
              <el-input
                v-model="formData.password"
                placeholder="请输入验证码"
                type="number"
                maxlength="6"
                prefix-icon="el-icon-key"
              ></el-input>
            </span>
            <el-button type="primary" :disabled="!phoneAvalible" @click="getSmsCode" :loading="getSmsCodeLoading">{{smsCodeText}}</el-button>
          </div>
        </el-form-item>

        <!--没有账号、验证码登录-->
        <el-form-item class="form-item">
          <div class="login-blocks">
            <span>
              没有账号?
              <a href="javascript:void(0)" @click="toRegister">立即注册</a>
            </span>
            <a href="javascript:void(0)" @click="switchLoginType"
              >{{formData.type ? '验证码登录' : '账号密码登录'}}</a
            >
          </div>
        </el-form-item>

        <!--登录按钮-->
        <el-form-item class="form-item">
          <button class="submit-btn" @click="login">登录</button>
          <div class="checkbox">
            <el-checkbox v-model="rememberLoginStatus"></el-checkbox>
            <span>七天内自动登录</span>
          </div>
        </el-form-item>
      </el-form>

      <!--服务协议-->
      <div class="footer-text">
        <span>登录即代表您已同意</span>
        <span>《服务协议和隐私政策》</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mapActions} from "vuex";
import {login, getSmsCode} from '@/http/request'
export default {
  name: "login",
  data() {
    return {
      count: 60,
      startDown: false,
      downTimer: null,
      getSmsCodeLoading: false, // 获取验证码loading
      formData: {
        phone: '',
        password: '',
        type: 1, // 1: 手机号验证码登录, 0: 账号密码登录
      }
    };
  },
  computed: {
    rememberLoginStatus: {
        get() {
            return this.$store.state.rememberLoginStatus
        },
        set(data) {
            this.$store.commit("set_remember_login_status", data);
        },
    },
    show: {
      get() {
        return this.$store.state.showLoginPop;
      },
      set(data) {
        this.$store.commit("set_show_login_pop", data);
      },
    },

    phoneAvalible() {
      return !!this.formData.phone
    },

    // 获取验证码code
    smsCodeText() {
      if (this.startDown) {
        return `${this.count}s`
      }
      return "请获取验证码"
    },

    rules() {
      // 自定义规则校验验证码
      const validatePassword = (rule, value, callback) => {
        if (!value) {
          const msg = this.formData.type ? '密码不能为空' : '验证码不能为空';
          return callback(new Error(msg))
        }

        const len = value.toString().length;
        // 验证码登录
        if (!this.formData.type) {
          if (len < 6) {
            return callback(new Error('验证码长度不正确'))
          }
          callback()
        }

        // 密码登录
        if (this.formData.type) {
          if (len < 6 || len > 18) {
            return callback(new Error('密码长度不正确'))
          }
          callback()
        }

      }

      return {
        phone: [
          {required: true, message: '手机号/账号不能为空', trigger: 'blur'},
          {pattern: /^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/, message: '手机号/账号格式不正确', trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword,  trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
      ...mapActions(["setShowLoginPop", "setToken", "setUserInfo", 'setLoginStatus']),

    // 切换登录方式
    switchLoginType() {
      this.formData.type = Number(!this.formData.type)
    },

    // 获取验证码
    getSmsCode() {
      this.getSmsCodeLoading = true;
      getSmsCode(this.formData.phone, 0).then(({data}) => {
        if (data.code === 0) {
          this.$message({
            type: 'success',
            message: '获取验证码成功'
          })

          // 开启倒计时
          this.down()
        } else {
          this.getSmsCodeLoading = false;
          this.$message({
            type: 'error',
            message: data.msg
          })
        }
      })
    },

    down() {
      if (!this.startDown) {
        this.downTimer = setInterval(() => {
          this.count --;
          if (this.count < 0) {
            this.count = 0;
            this.startDown = false;
            clearInterval(this.downTimer)
          }
        }, 1000);
      }
    },

    // 跳转注册
    toRegister() {
      this.show = false;
      this.$router.push("/register");
    },

    // 登录
    login() {
      login({...this.formData, isSevenDay: Number(this.rememberLoginStatus)}).then(({data}) => {
        if (data.code === 0) {
          this.setUserInfo(data.data.userInfo);
          this.setToken(data.data.token);
          this.setLoginStatus(true);
          this.setShowLoginPop(false);
          this.$message({
            message: '登录成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          });
        }
      }).catch(({data}) => {
        this.$message({
          message: data.msg,
          type: 'error'
        });
      })
    }
  },
};
</script>

<style lang="less" scoped>
.login-title {
  font-size: 17px;
  font-weight: 500;
  color: #1399dc;
  line-height: 29px;
}
.form-item {
  margin-bottom: 0;
  padding: 0 10px;
  .login-blocks {
    display: flex;
    font-size: 12px;
    color: #777;
    & > span {
      flex: 1;
      a {
        color: #1399dc;
        text-decoration: none;
      }
    }
    a {
      flex: 1;
      text-align: right;
      color: #777;
    }
  }
  .submit-btn {
    width: 100%;
    height: 38px;
    display: block;
    margin: 30px auto 0;
    background: linear-gradient(90deg, #1799dc, #1b72b8);
    border-radius: 4px;
    color: #fff;
  }
  .checkbox {
    text-align: center;
    font-size: 12px;
    color: #777;
    span {
      margin-left: 5px;
    }
  }
  .code {
    width: 100%;
    display: flex;
    span {
      flex: 1;
    }
    button {
      margin-left: 5px;
      // background: #f1f2f2;
      border: none;
      // color: #999999;
      font-weight: 400;
    }
  }
}
.footer-text {
  margin-top: 35px;
  text-align: center;
  font-size: 12px;
  color: #777;
  span:last-child {
    color: #1399dc;
  }
}
</style>
